import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DialogCloseService } from 'src/app/_services/dialogClose.service';
import { MaterialModule } from 'src/app/material.module';
import { SharedModule } from 'src/app/shared.module';

@Component({
    selector: 'test-login-component',
    templateUrl: 'test-login.component.html',
    standalone: true, // Required for Angular 18's new standalone components
    imports: [
        SharedModule,
        MaterialModule
    ]
})

export class TestLoginComponent {
    title: string = "";
    public passowrdModel: string = "";
    positiveText: string = "Login";
    response: boolean = true;
    constructor(
        public dialogRef: MatDialogRef<TestLoginComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private closeDialogService: DialogCloseService) {

        if (data.positiveKey != undefined) {
            this.passowrdModel = data.positiveKey;
        }
        this.title = data.title;
        if (window.location.href.includes('salesctd') == true) {
            this.positiveText = "Exit Test"
        }
        else {
            this.positiveText = "Login";
        }
        this.closeDialogService.emitRegisterDialog(dialogRef);
    }
    login() {
        if (this.positiveText == "Login" && this.passowrdModel == "54321") {
            this.response = true;
            this.dialogRef.close("test");
        }
        else if (this.positiveText == "Exit Test") {
            this.dialogRef.close("exit");
        }
        else {
            this.response = false;
        }
    }
    onNoClick(): void {
        this.dialogRef.close();
    }
}